import { AppState } from '../..';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const selectAllTemporaryMarkers = (state: AppState) =>
  state.temporaryMarkers.markers;
